import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadContext } from '../store/actions/Contexto';

export const useLoadContext = () => {
    const dispatch = useDispatch();
    const contexts = useSelector((store) => store.contexts);

    useEffect(() => {
        const getContext = async () => {
            await dispatch(loadContext());
        };

        getContext();
    }, [dispatch]);

    return contexts;
};

export default useLoadContext;